const NextI18Next = require("next-i18next").default;
const path = require("path");

module.exports = new NextI18Next({
  defaultLanguage: process.env.NEXT_PUBLIC_APP_LOCALE,
  otherLanguages: ['fa'],
  localePath: path.resolve("./public/static/locales"),
});
